import Vue from 'vue';
// @ts-ignore
import Vuetify from 'vuetify/lib';
// Languages
import es from '../locale/es';
import en from '../locale/en';

Vue.use(Vuetify);

const THEME_COLORS = {
    primary: '#822899',
    secondary: '#822899',
    roma_rcolor: '#81007e',
    roma_acolor: '#f9d912',
    purpura_base: '#743085',
    azul_base: '#389CC3',
    purpura_base_dark: '#571B66',
    purpura_base_lighten_1: '#822899',
    purpura_base_lighten_2: '#BC7CCC',
    purpura_base_lighten_3: '#F1E5FF',
    neutro0: '#1A161B',
    neutro1: '#6B6B6B',
    neutro4: '#ECE9E9',
    neutral_black: '#101840',
    accent: '#743085',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
};

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: THEME_COLORS,
    },
  },
    lang: {
      locales: { es, en },
      // Verificamos namespace roma y tomamos su lenguaje
      current: (sessionStorage.roma) ? JSON.parse(sessionStorage.roma).selectedLanguage : 'es',
    },
  icons: {
    iconfont: 'fa',
  },
});
